/* Brainy Bounce · Bo's Discovery Lab (STEM collection).
   Lightweight SVG demonstrations, one shared animation loop, paused when offscreen or the tab is hidden.
   All demos are simplified illustrations, not product-performance simulations. */
(function () {
  'use strict';
  var PI = Math.PI;
  function still() { return document.documentElement.classList.contains('bb-still') || window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function clamp(x, a, b) { return x < a ? a : x > b ? b : x; }
  function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }

  // ---------------- hero: goggles + Bo reactions ----------------
  var labBo = document.querySelector('[data-lab-bo]');
  var gBtn = document.querySelector('[data-lab-goggles]');
  if (gBtn && labBo) gBtn.addEventListener('click', function () {
    var on = !labBo.classList.contains('has-goggles');
    labBo.classList.toggle('has-goggles', on);
    gBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    gBtn.textContent = on ? 'Goggles off' : 'Goggles on';
  });
  function boReact() {
    var m = labBo && labBo.querySelector('[data-bb-mascot]'); if (!m || still()) return;
    m.classList.remove('is-squished'); void m.offsetWidth; m.classList.add('is-squished');
  }
  function boLook() {   // Bo glances down toward the workbench when a demo is chosen
    var g = labBo && labBo.querySelector('.bb-mascot__look'); if (!g) return;
    g.style.transform = 'translate(0px, 6px)';
  }

  var bench = document.querySelector('[data-lab-bench]');
  if (!bench || bench.__bb) return; bench.__bb = true;
  var tabs = Array.prototype.slice.call(bench.querySelectorAll('[data-lab-tab]'));
  var panels = {}; bench.querySelectorAll('[data-lab-panel]').forEach(function (p) { panels[p.getAttribute('data-lab-panel')] = p; });
  var active = 'solar';
  function q(sel) { return panels[active].querySelector(sel); }
  function svgPoint(svg, e) { var pt = svg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY; return pt.matrixTransform(svg.getScreenCTM().inverse()); }

  // ---------------- tabs ----------------
  function select(name, focus) {
    active = name;
    tabs.forEach(function (t) { var on = t.getAttribute('data-lab-tab') === name; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
    Object.keys(panels).forEach(function (k) { panels[k].hidden = k !== name; });
    boLook(); kick();
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { select(t.getAttribute('data-lab-tab')); });
    t.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (e.key === 'Home') d = -i; if (e.key === 'End') d = tabs.length - 1 - i;
      if (d) { e.preventDefault(); select(tabs[(i + d + tabs.length) % tabs.length].getAttribute('data-lab-tab'), true); }
    });
  });

  // ---------------- 1. solar car ----------------
  var solar = { light: 0, x: 0, ang: 0 };
  var sp = panels.solar, sSlider = sp.querySelector('[data-solar-light]');
  sSlider.addEventListener('input', function () { solar.light = sSlider.value / 100; if (solar.light > 0.05) boReact(); kick(); drawSolar(0); });
  function drawSolar(dt) {
    var L = solar.light, moving = L > 0.08 && !still();
    sp.querySelector('.lab-beams').setAttribute('opacity', (L * 0.9).toFixed(2));
    sp.querySelector('.lab-car__glow').setAttribute('opacity', (L * 0.45).toFixed(2));
    sp.querySelector('.lab-sun').style.opacity = (0.45 + L * 0.55).toFixed(2);
    if (moving) { var v = 30 + 170 * L; solar.x += v * dt; if (solar.x > 400) solar.x = 0; solar.ang += (v / 16) * dt * 57.3; }
    sp.querySelector('.lab-car').setAttribute('transform', 'translate(' + (40 + solar.x).toFixed(1) + ' 0)');
    sp.querySelectorAll('.lab-wheel').forEach(function (w) { w.setAttribute('transform', 'rotate(' + solar.ang.toFixed(1) + ' ' + w.getAttribute('data-cx') + ' ' + w.getAttribute('data-cy') + ')'); });
    return moving;
  }

  // ---------------- 2. robot workshop ----------------
  var rp = panels.robot, robot = { bot: 'crawler', t: -1 }, doodlePath = rp.querySelector('.lab-doodle');
  function showBot(b) {
    robot.bot = b; robot.t = -1;
    rp.querySelectorAll('[data-bot-pick]').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-bot-pick') === b ? 'true' : 'false'); });
    rp.querySelectorAll('.lab-bot').forEach(function (g) { g.hidden = g.getAttribute('data-bot') !== b; });
    doodlePath.style.display = b === 'doodle' ? '' : 'none';
    drawRobot(0, 0);
  }
  rp.querySelectorAll('[data-bot-pick]').forEach(function (x) { x.addEventListener('click', function () { showBot(x.getAttribute('data-bot-pick')); }); });
  rp.querySelector('[data-bot-go]').addEventListener('click', function () { robot.t = still() ? 1 : 0; boReact(); drawRobot(0, robot.t); kick(); });
  function drawRobot(dt, t) {
    var g = rp.querySelector('.lab-bot[data-bot="' + robot.bot + '"]'), k = Math.max(0, t);
    if (robot.bot === 'crawler') g.setAttribute('transform', 'translate(' + (k * 300).toFixed(1) + ' 0) rotate(' + (t > 0 && t < 1 ? Math.sin(k * 40) * 4 : 0).toFixed(1) + ' 120 200)');
    if (robot.bot === 'delivery') { var x = ease(k) * 300; g.setAttribute('transform', 'translate(' + x.toFixed(1) + ' 0)'); g.querySelectorAll('.lab-wheel').forEach(function (w) { w.setAttribute('transform', 'rotate(' + (x * 4).toFixed(1) + ' ' + w.getAttribute('data-cx') + ' ' + w.getAttribute('data-cy') + ')'); }); }
    if (robot.bot === 'doodle') {
      doodlePath.setAttribute('stroke-dashoffset', (100 - k * 100).toFixed(1));
      var len = doodlePath.getTotalLength(), p = doodlePath.getPointAtLength(len * k);
      g.querySelector('.lab-doodlebot').setAttribute('transform', 'translate(' + p.x.toFixed(1) + ' ' + (p.y - 44).toFixed(1) + ')');
    }
    if (robot.bot === 'flyer') { var a = (t >= 0 && t < 1) ? k * 3600 : 0; g.querySelector('.lab-prop').setAttribute('transform', 'translate(-14 64) rotate(' + a.toFixed(0) + ')'); }
  }
  function stepRobot(dt) {
    if (robot.t < 0 || robot.t >= 1) return false;
    robot.t = Math.min(1, robot.t + dt / 3); drawRobot(dt, robot.t);
    return robot.t < 1;
  }

  // ---------------- 3. Newton's cradle ----------------
  var cp = panels.cradle, csvg = cp.querySelector('svg'), balls = Array.prototype.slice.call(cp.querySelectorAll('.lab-ball'));
  var cradle = { s: -1, A0: 0, drag: null };
  var PIV = balls.map(function (b, i) { return [212 + i * 44, 32]; });
  function setBall(i, deg) { balls[i].setAttribute('transform', 'rotate(' + (-deg).toFixed(2) + ' ' + PIV[i][0] + ' ' + PIV[i][1] + ')'); }
  function restCradle() { cradle.s = -1; balls.forEach(function (b, i) { setBall(i, 0); }); }
  function release(A) {
    cradle.A0 = clamp(A, 8, 48); boReact();
    if (still()) { restCradle(); return; }
    cradle.s = 0; kick();
  }
  function stepCradle(dt) {
    if (cradle.s < 0) return false;
    cradle.s += dt;
    var T = 1.1, qd = T / 4, L = 0, Rr = 0;
    if (cradle.s < qd) L = -cradle.A0 * Math.cos((cradle.s / qd) * PI / 2);
    else {
      var u = (cradle.s - qd) / (T / 2), k = Math.floor(u), f = u - k, A = cradle.A0 * Math.pow(0.86, k + 1);
      if (A < 1.2) { restCradle(); return false; }
      if (k % 2 === 0) Rr = Math.sin(f * PI) * A; else L = -Math.sin(f * PI) * A;
    }
    setBall(0, L); setBall(4, Rr); setBall(1, 0); setBall(2, 0); setBall(3, 0);
    return true;
  }
  cp.querySelector('[data-cradle-go]').addEventListener('click', function () { restCradle(); release(38); });
  var b0 = balls[0].querySelector('circle'); b0.style.cursor = 'grab'; b0.style.touchAction = 'none';
  b0.addEventListener('pointerdown', function (e) { restCradle(); cradle.drag = e.pointerId; try { b0.setPointerCapture(e.pointerId); } catch (x) {} e.preventDefault(); });
  b0.addEventListener('pointermove', function (e) {
    if (cradle.drag !== e.pointerId) return;
    var p = svgPoint(csvg, e), deg = Math.atan2(p.x - PIV[0][0], p.y - PIV[0][1]) * -180 / PI;
    cradle.dragDeg = clamp(deg, 0, 50); setBall(0, -cradle.dragDeg);
  });
  ['pointerup', 'pointercancel'].forEach(function (ev) { b0.addEventListener(ev, function () { if (cradle.drag === null) return; cradle.drag = null; var A = cradle.dragDeg || 0; cradle.dragDeg = 0; if (A > 5) release(A); else restCradle(); }); });

  // ---------------- 4. circuit ----------------
  var ckp = panels.circuit, swBtn = ckp.querySelector('[data-circuit-switch]'), circuit = { on: false, off: 0 };
  function drawCircuit() {
    var arm = ckp.querySelector('.lab-switch__arm');
    arm.setAttribute('x2', circuit.on ? 370 : 366); arm.setAttribute('y2', circuit.on ? 70 : 40);
    ckp.querySelector('.lab-bulb__glow').setAttribute('opacity', circuit.on ? 0.75 : 0);
    ckp.querySelector('.lab-flow').setAttribute('opacity', circuit.on ? 1 : 0);
    swBtn.setAttribute('aria-pressed', circuit.on ? 'true' : 'false');
    swBtn.textContent = circuit.on ? 'Open the switch' : 'Close the switch';
  }
  swBtn.addEventListener('click', function () { circuit.on = !circuit.on; if (circuit.on) boReact(); drawCircuit(); kick(); });
  function stepCircuit(dt) {
    if (!circuit.on || still()) return false;
    circuit.off -= dt * 40; ckp.querySelector('.lab-flow').setAttribute('stroke-dashoffset', circuit.off.toFixed(1));
    return true;
  }

  // ---------------- 5. wooden machines ----------------
  var wp = panels.wood, armIn = wp.querySelector('[data-arm]'), wood = { target: 0.3, v: 0.3, gears: false, gang: 0 };
  function drawArm() {
    var v = wood.v;
    wp.querySelector('.lab-boom').setAttribute('transform', 'rotate(' + (-8 - v * 34).toFixed(1) + ' 167 156)');
    wp.querySelector('.lab-stick').setAttribute('transform', 'rotate(' + (18 - v * 46).toFixed(1) + ' 300 157)');
    wp.querySelector('.lab-bucket').setAttribute('transform', 'rotate(' + (-25 + v * 55).toFixed(1) + ' 302 236)');
  }
  armIn.addEventListener('input', function () { wood.target = armIn.value / 100; if (still()) { wood.v = wood.target; drawArm(); } kick(); });
  armIn.addEventListener('change', boReact);
  var gearBtn = wp.querySelector('[data-gear-toggle]');
  gearBtn.addEventListener('click', function () {
    wood.gears = !wood.gears;
    gearBtn.setAttribute('aria-pressed', wood.gears ? 'true' : 'false');
    gearBtn.textContent = wood.gears ? 'Show the excavator' : 'Show the gear model';
    wp.querySelector('.lab-planet').hidden = !wood.gears; wp.querySelector('.lab-excavator').style.display = wood.gears ? 'none' : '';
    wp.querySelector('[data-arm-ctl]').hidden = wood.gears;
    if (wood.gears) boReact(); kick();
  });
  function stepWood(dt) {
    var busy = false;
    if (Math.abs(wood.target - wood.v) > 0.002) { wood.v += (wood.target - wood.v) * Math.min(1, dt * 6); drawArm(); busy = true; }
    if (wood.gears && !still()) {
      wood.gang += dt * 25;
      wp.querySelector('.lab-gear-big').setAttribute('transform', 'rotate(' + wood.gang.toFixed(1) + ')');
      wp.querySelector('.lab-orbit').setAttribute('transform', 'rotate(' + (wood.gang * 1.6).toFixed(1) + ')');
      busy = true;
    }
    return busy;
  }

  // ---------------- 6. science lab (decorative) ----------------
  var lp = panels.lab, fx = { kind: 'foam', t: -1, items: [] }, NS = 'http://www.w3.org/2000/svg';
  function el(tag, attrs, parent) { var n = document.createElementNS(NS, tag); for (var k in attrs) n.setAttribute(k, attrs[k]); parent.appendChild(n); return n; }
  function clearFx() { ['.lab-foam', '.lab-crystals', '.lab-swirl'].forEach(function (s) { var g = lp.querySelector(s); while (g.firstChild) g.removeChild(g.firstChild); }); fx.items = []; fx.t = -1; }
  function showFx(k) {
    fx.kind = k; clearFx();
    lp.querySelectorAll('[data-fx-pick]').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-fx-pick') === k ? 'true' : 'false'); });
    lp.querySelectorAll('.lab-fx').forEach(function (g) { g.hidden = g.getAttribute('data-fx') !== k; });
  }
  lp.querySelectorAll('[data-fx-pick]').forEach(function (x) { x.addEventListener('click', function () { showFx(x.getAttribute('data-fx-pick')); }); });
  lp.querySelector('[data-fx-go]').addEventListener('click', function () {
    clearFx(); boReact();
    var cols = ['#ffffff', '#f3ecff', '#e2d6ff', '#ffd6f0'];
    if (fx.kind === 'foam') { var g = lp.querySelector('.lab-foam'); for (var i = 0; i < 46; i++) var cx0 = 262 + Math.random() * 76; fx.items.push({ n: el('circle', { cx: cx0, cy: 180, r: 0, fill: cols[i % 4] }, g), cx: cx0, d: i / 46, h: 60 + Math.random() * 110, r: 8 + Math.random() * 12, dx: (Math.random() - 0.5) * 50 }); }
    if (fx.kind === 'crystal') { var c = lp.querySelector('.lab-crystals'), cc = ['#b6f23a', '#2fe0d6', '#b9a4ff', '#ff8fd0']; for (var j = 0; j < 9; j++) { var x = 230 + j * 18, h = 50 + Math.random() * 80, w = 12 + Math.random() * 8; fx.items.push({ n: el('path', { d: 'M' + (x - w) + ' 222 L' + (x - w * 0.6) + ' ' + (222 - h * 0.8) + ' L' + x + ' ' + (222 - h) + ' L' + (x + w * 0.6) + ' ' + (222 - h * 0.8) + ' L' + (x + w) + ' 222Z', fill: cc[j % 4], opacity: 0.85, transform: 'translate(' + x + ' 222) scale(0) translate(' + -x + ' -222)' }, c), x: x, d: j / 12 }); } }
    if (fx.kind === 'swirl') { var s = lp.querySelector('.lab-swirl'), sc = ['#ff2e93', '#2fe0d6', '#ffd23f', '#b6f23a', '#8a5cff']; for (var k = 0; k < 5; k++) fx.items.push({ n: el('circle', { cx: 0, cy: 0, r: 0, fill: sc[k], opacity: 0.75 }, s), a: k / 5 * PI * 2 }); }
    fx.t = still() ? 1 : 0; drawFx(); kick();
  });
  function drawFx() {
    var t = Math.max(0, fx.t);
    fx.items.forEach(function (it) {
      if (fx.kind === 'foam') { var k = clamp((t - it.d * 0.6) / 0.4, 0, 1); it.n.setAttribute('r', (it.r * k).toFixed(1)); it.n.setAttribute('cy', (180 - it.h * ease(k)).toFixed(1)); it.n.setAttribute('cx', (it.cx + it.dx * ease(k) * 0.4).toFixed(1)); }
      if (fx.kind === 'crystal') { var g = ease(clamp((t - it.d * 0.5) / 0.5, 0, 1)); it.n.setAttribute('transform', 'translate(' + it.x + ' 222) scale(' + g.toFixed(3) + ') translate(' + -it.x + ' -222)'); }
      if (fx.kind === 'swirl') { var a = it.a + t * PI * 3, r = 20 + t * 90; it.n.setAttribute('cx', (Math.cos(a) * r * 0.6).toFixed(1)); it.n.setAttribute('cy', (Math.sin(a) * r * 0.6).toFixed(1)); it.n.setAttribute('r', (18 + t * 40).toFixed(1)); it.n.setAttribute('opacity', (0.8 - t * 0.35).toFixed(2)); }
    });
  }
  function stepFx(dt) { if (fx.t < 0 || fx.t >= 1) return false; fx.t = Math.min(1, fx.t + dt / 3); drawFx(); return fx.t < 1; }

  // ---------------- reset buttons ----------------
  bench.querySelectorAll('[data-lab-reset]').forEach(function (b) {
    b.addEventListener('click', function () {
      var name = b.closest('[data-lab-panel]').getAttribute('data-lab-panel');
      if (name === 'solar') { solar.light = 0; solar.x = 0; solar.ang = 0; sSlider.value = 0; drawSolar(0); }
      if (name === 'robot') showBot(robot.bot);
      if (name === 'cradle') restCradle();
      if (name === 'circuit') { circuit.on = false; drawCircuit(); }
      if (name === 'wood') { wood.target = wood.v = 0.3; armIn.value = 30; drawArm(); if (wood.gears) gearBtn.click(); }
      if (name === 'lab') showFx(fx.kind);
    });
  });

  // ---------------- one shared loop ----------------
  var running = false, raf = 0, last = 0, visible = false;
  function frame(now) {
    var dt = Math.min(0.05, (now - (last || now)) / 1000); last = now;
    var busy = false;
    if (active === 'solar') busy = drawSolar(dt);
    if (active === 'robot') busy = stepRobot(dt);
    if (active === 'cradle') busy = stepCradle(dt) || cradle.drag !== null;
    if (active === 'circuit') busy = stepCircuit(dt);
    if (active === 'wood') busy = stepWood(dt);
    if (active === 'lab') busy = stepFx(dt);
    if (busy && visible && !document.hidden) raf = requestAnimationFrame(frame); else running = false;
  }
  function kick() { if (!running && visible && !document.hidden) { running = true; last = 0; raf = requestAnimationFrame(frame); } }
  new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) kick(); else { running = false; cancelAnimationFrame(raf); } }).observe(bench);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) kick(); });
  document.addEventListener('bb:motion', function () { kick(); });

  showBot('crawler'); restCradle(); drawCircuit(); drawArm(); drawSolar(0); showFx('foam');
  bench.classList.add('is-ready');
  if (/[?&]bbtest/.test(location.search)) window.__bbLab = { select: select, state: function () { return { active: active, solar: solar, robot: robot.t, cradle: cradle.s, circuit: circuit.on, wood: wood.v, fx: fx.t }; } };
})();
